import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function KitProDetails() {
  const comparison = [{
    sit: 'Tu scooter de alta potencia falla y no encontrás info',
    sin: 'Buscás horas en foros sin respuesta',
    con: 'Guía específica 60–72V. Lista.'
  }, {
    sit: 'Tenés varios scooters y no sabés cómo organizarlos',
    sin: 'Todo en la memoria o en papeles sueltos',
    con: 'Sistema de registro de flota. Profesional.'
  }, {
    sit: 'El técnico te dice algo y no entendés si es verdad',
    sin: 'Pagás y confiás a ciegas',
    con: 'Glosario + checklist de validación. Ya están.'
  }, {
    sit: 'Querés saber exactamente cuándo hacer cada revisión',
    sin: 'Esperás a que se rompa',
    con: 'Calendario de gestión anual. Todo calculado.'
  }, {
    sit: 'Compraste un scooter usado y no sabés en qué estado está',
    sin: 'Revisás lo que podés y rezás',
    con: 'Protocolo de inspección inicial completo.'
  }];
  const includes = ['Guía extendida scooters 60–72V / doble motor', 'Sistema de registro y gestión de flota', 'Protocolo de inspección inicial (scooter nuevo o usado)', 'Checklist de validación de service (para no pagar de más)', 'Calendario anual de gestión con alertas', 'Fichas técnicas de referencia por componente', 'Guía de compra de repuestos (qué pedir, qué evitar)', 'Sistema de registro de fallas e historial'];
  return <section className="py-20 px-4 bg-surface/30" data-id="element-167">
      <div className="max-w-5xl mx-auto" data-id="element-168">
        <div className="text-center mb-12" data-id="element-169">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white" data-id="element-170">
            🔧 ¿QUÉ AGREGA EL KIT SISTEMA DE GESTIÓN PRO?
          </h2>
        </div>

        <div className="overflow-x-auto mb-16 hide-scrollbar" data-id="element-171">
          <table className="w-full min-w-[800px] border-collapse" data-id="element-172">
            <thead data-id="element-173">
              <tr className="border-b border-border" data-id="element-174">
                <th className="text-left py-4 px-6 text-muted font-medium w-1/3" data-id="element-175">
                  Situación real
                </th>
                <th className="text-left py-4 px-6 text-danger font-medium w-1/3" data-id="element-176">
                  ❌ Sin Kit
                </th>
                <th className="text-left py-4 px-6 text-accent font-medium w-1/3" data-id="element-177">
                  ✅ Con Kit
                </th>
              </tr>
            </thead>
            <tbody data-id="element-178">
              {comparison.map((row, idx) => <tr key={idx} className="border-b border-border/50 hover:bg-surface/50 transition-colors" data-id="element-179">
                  <td className="py-4 px-6 text-white font-medium" data-id="element-180">
                    {row.sit}
                  </td>
                  <td className="py-4 px-6 text-gray-400" data-id="element-181">{row.sin}</td>
                  <td className="py-4 px-6 text-accent font-medium" data-id="element-182">
                    {row.con}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-surface border border-accent/30 rounded-2xl p-8 md:p-12" data-id="element-183">
          <h3 className="text-2xl font-heading font-bold text-white mb-8 text-center" data-id="element-184">
            ✅ EL KIT SISTEMA DE GESTIÓN PRO INCLUYE:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-185">
            {includes.map((item, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-186">
                <CheckCircle2 className="text-accent shrink-0 mt-0.5" size={20} data-id="element-187" />
                <span className="text-gray-300" data-id="element-188">{item}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}